import { render, staticRenderFns } from "./RelatedProject.vue?vue&type=template&id=54150e43&scoped=true&"
import script from "./RelatedProject.vue?vue&type=script&lang=js&"
export * from "./RelatedProject.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProject.vue?vue&type=style&index=0&id=54150e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54150e43",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Media: require('/vercel/path0/components/Media.vue').default,Animation: require('/vercel/path0/components/Animation.vue').default})
